export const FEATURE_TOGGLE_STORE_KEY = 'featureToggle';
